import {URL_STATICS_IMAGES} from '../base.js'
import {PTA_PATH_PATTERN, SECOND_HAND_PATH_PATTERN} from './page.js'

export const MARKET_PLAYERS_CARD_DATA = {
  private: {
    media: {
      src: `${URL_STATICS_IMAGES}market-player-private@2x.jpg`,
      alt: 'publisher-particular'
    },
    text: {
      title: 'CARD_MARKET_PLAYERS_PRIVATE_MOTOS_TITLE',
      description: 'CARD_MARKET_PLAYERS_PRIVATE_MOTOS_TEXT'
    },
    link: PTA_PATH_PATTERN
  },
  secondHandBuyer: {
    media: {
      src: `${URL_STATICS_IMAGES}market-player-second-hand-buyer-motos@2x.jpg`,
      alt: 'buyer'
    },
    text: {
      title: 'CARD_MARKET_PLAYERS_SECOND_HAND_BUYER_MOTOS_TITLE',
      description: 'CARD_MARKET_PLAYERS_SECOND_HAND_BUYER_MOTOS_TEXT'
    },
    link: SECOND_HAND_PATH_PATTERN
  }
}
